<template>
  <div class="content-dashboard">
    <div class="row">
      <div class="col-lg-12">
        <div v-if="registerStore.loading && !selected" class="loading">Loading...</div>
        <div v-else-if="mode === 'simple'">
          <h3 class="mb-4 mt-2">Frais de port</h3>
          <div class="box-chart mb-3 w-100 p-5">
            <div class="gamme-info">
              <h3 class="dark-color">Configurer les frais de port</h3>

              <div class="d-flex gap-4 justify-content-between align-items-baseline">
                <div class="check-block d-flex gap-3 mt-5">
                  <label
                    v-for="option in options"
                    :key="option"
                    :class="['check-button', { active: selected === option.value }]"
                  >
                    <input
                      type="radio"
                      :value="option.value"
                      v-model="selected"
                      hidden
                      @change="handleOptionChange(option.value)"
                    />
                    <span class="label-text">{{ option.name }}</span>
                    <span class="check-icon" v-if="selected === option.value"
                      ><i class="ti ti-check-box ps-2"></i
                    ></span>
                  </label>
                </div>
              </div>
              <div v-if="selected === 'charge_client'" class="input-form mt-4">
                <label class="label-control">Franco à partir de</label>
                <div class="input-group rounded-pill border overflow-hidden">
                  <input
                    type="number"
                    class="form-control border-0 shadow-none"
                    v-model.number="francoAPartirDe"
                    placeholder="0"
                    min="0"
                  />
                  <span class="input-group-text bg-light border-0">€TTC</span>
                </div>
                <div class="alert alert-warning alert-dismissible fade show mt-2">
                  <span class="info-text">
                    Nous recommandons un franco de port à 68€ TTC, basé sur le prix de vente conseillé de notre
                    catalogue, mais vous êtes libre de le personnaliser.
                  </span>
                </div>
              </div>

              <div class="d-flex flex-column gap-3 justify-content-center align-items-end">
                <button class="btn btn-orange" @click="saveChanges" :disabled="saving">
                  {{ saving ? "Enregistrement..." : "Enregistrer" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref } from "vue";
  import { useRegisterStore } from "@/stores/register";
  import { useToast } from "vue-toastification";
  import { updateVeterinaireFrais } from "@/api/veterinaireService";

  export default {
    name: "FraisPort",
    setup() {
      const mode = ref("simple");
      return { mode };
    },
    data() {
      return {
        registerStore: useRegisterStore(),
        options: [
          { name: "Offert", value: "offert" },
          { name: "Frais de port à la charge du client", value: "charge_client" },
        ],
        selected: null,
        selectedChecks: [],
        francoAPartirDe: 0,
        saving: false,
        identifier: null,
      };
    },
    async created() {
      await this.registerStore.fetchVeterinaire();
      this.initializeData();
    },
    methods: {
      initializeData() {
        const subscription = this.registerStore.Veterinaire.hasSubscription;
        if (subscription) {
          console.log(subscription.francoApartirDe);
          this.selected = subscription.fraisPort;
          this.francoAPartirDe = subscription.francoApartirDe;
          this.identifier = subscription.id;
        }
      },
      handleOptionChange(option) {
        this.selected = option;
      },
      async saveChanges() {
        const toast = useToast();

        // Validation
        if (!this.selected) {
          toast.error(this.$t("frais_port.select_option"));
          return;
        }
        if (this.selected === "charge_client" && (this.francoAPartirDe < 0 || isNaN(this.francoAPartirDe))) {
          toast.error(this.$t("frais_port.invalid_franco"));
          return;
        }

        this.saving = true;
        try {
          const id = this.identifier;
          const payload = {
            fraisPort: this.selected,
            francoApartirDe: this.francoAPartirDe,
          };
          const updatedSubscription = await updateVeterinaireFrais(id, payload);
          toast.success(this.$t("frais_port.saved_success"));

          this.registerStore.updateVeterinaire({
            ...this.registerStore.Veterinaire,
            hasSubscription: updatedSubscription,
          });
        } catch (error) {
          if (error.response?.status === 400) {
            toast.error(this.$t("frais_port.invalid_data"));
          } else if (error.response?.status === 401) {
            toast.error(this.$t("frais_port.unauthorized"));
            this.$router.push({ name: "Home" });
          } else {
            toast.error(this.$t("frais_port.save_error"));
          }
          console.error("Error saving subscription:", error);
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>

<style scoped>
  .loading {
    text-align: center;
    padding: 20px;
    font-size: 1.2em;
  }
</style>
